<template>
  <div class="historical-applicant-list" v-if="list && list.length">
    <div class="list-title">历史申请人</div>


    <switch-card-list :step-number="2">
      <div :class="['applicant-list', setMaxWidth ? 'max-width' : '']" id="applicantListRef">
        <div :class="['applicant-item', selectedApplicantIdList.includes(item.archives_id) ? 'active' : '']" v-for="(item, index) in list.slice(0, 30)" :key="index" @click="onSelectApplicant(item)">
          {{ item.applicant_name }}
        </div>
      </div>
    </switch-card-list>

  </div>
</template>


<script>
import Http from '@/libs/http';
import switchCardList from './switch-card-list.vue';
import 'pinyin4js';
import utils from '@/libs/utils';

export default {
  components: {
    switchCardList,
  },
  props: {
    insurants: {
      type: Array,
      default: () => ([]),
    },
    insuranceData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 业务逻辑
      loading: false,
      applicantModel: null,
      selectedApplicantIdList: [],
      setMaxWidth: false,
    };
  },
  computed: {
    list() {
      if (!this.applicantModel) return [];
      const keys = Object.keys(this.applicantModel);
      if (!keys || !keys.length) return [];
      const applicantList = keys.reduce((pre, cur) => {
        const currentList = this.applicantModel[cur];
        return pre.concat(...currentList || []);
      }, []);
      return applicantList;
    },
  },
  watch: {
    insurants: {
      handler(val) {
        if (!val) {
          this.selectedApplicantIdList = [];
          return;
        }
        // 过滤掉自己创建
        this.selectedApplicantIdList = val.filter(it => it.archives_id).map(it => it.archives_id);
      },
      immediate: true,
      deep: true,
    },
    list: {
      handler() {
        this.checkOverflow();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Http.post('/archives_brief_query', {})
        .then((data) => {
          delete data.result.unknown;
          this.applicantModel = data.result;
          // this.getEachStepWidth();
          // 设置编辑时候数据回填----因为编辑时候没有archives_id但又需要回填选中，则需要动态再设置一个archives_id
          this.setInitSelected();
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    setInitSelected() {
      // if (this.$route.query.isEdit) {
      //   const keyList = this.list.map(it => `${it.applicant_name}_${it.passport_number}`);
      //   const insurantList = utils.deepCopy(this.value);
      //   console.log('dsadsadasdsa', keyList, insurantList);
      //   insurantList.forEach((item) => {
      //     const key = `${item.cname}_${item.card_code}`;
      //     if (keyList.includes(key)) {
      //       const selectItem = this.list.find(it => `${it.applicant_name}_${it.passport_number}` === key);
      //       item.archives_id = selectItem ? selectItem.archives_id : undefined;
      //     }
      //   });
      //   this.$emit('input', insurantList);
      // }
    },
    onSelectApplicant(record) {
      const index = this.selectedApplicantIdList.findIndex(id => id === record.archives_id);
      if (index !== -1) {
        this.selectedApplicantIdList.splice(index, 1);
        this.$emit('del-applicant', record.archives_id);
      } else {
        this.selectedApplicantIdList.push(record.archives_id);
        this.$emit('add-applicant', {
          archives_id: record.archives_id,
          cname: record.applicant_name,
          ename: this.calculatePinyinStr(record.applicant_name, 100),
          card_type: 2,
          card_code: record.passport_number, // 都是护照
          sex: record.gender,
          birthday: record.birthday ? new Date(record.birthday) : '',
          relation_id: this.insuranceData.is_self_insure ? 1 : undefined, // 默认本人
        });
      }
    },
    calculatePinyinStr(cname, length) {
      return PinyinHelper.convertToPinyinString(cname, '#', PinyinFormat.WITHOUT_TONE)
        .split('#')
        .map(pin => pin.substring(0, 1).toUpperCase() + pin.substring(1))
        .join('')
        .substring(0, length);
    },
    // 检查是否超过一行
    checkOverflow() {
      this.$nextTick(() => {
        const dom = document.getElementById('applicantListRef');
        if (dom && dom.clientHeight > 42) {
          this.setMaxWidth = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.historical-applicant-list {
  display: flex;
  flex-direction: column;
  .list-title {
    font-size: 16px;
    color: #2F333D;
    line-height: 16px;
    text-align: left;
  }
  /deep/ .applicant-list {
    display: flex;
    flex-wrap: wrap;
    &.max-width {
      width: 1520px;
    }
    .applicant-item {
      flex-shrink: 0;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #DEE2E6;
      line-height: 28px;
      text-align: center;
      padding: 0 46px;
      margin: 12px 16px 0 0;
      font-size: 14px;
      color: #2F333D;
      user-select: none;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background: #F3F8FF;
        border: 1px solid #599FFF;
        position: relative;
        border-radius: 2px 2px 4px 2px;
        &::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          position: absolute;
          z-index: 1;
          bottom: 0;
          right: 0;
          background: url(../../../../../../../../../assets/imgs/insurance-new/insurance-info/selected-icon.png) center center no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/components/historical-applicant-list.vue